import React from 'react'
import './Join.css'

export default function JoinError({errorData}) {

  const { 
    title, 
    note,
    blockers,
    supportOptions,
    userActions,
    ourActions,
    progressOptions,
  } = errorData;

  return (
    <div className='joinError'>
    {title                &&  <div className='joinErrTitle'> {title} </div>  }
    {note                 &&  <div className='joinErrInfo'>{note}</div>      }
    { blockers         &&  <div> 
                                <div className='joinErrItemTitle'>Explanation:</div>
                                {blockers.map( (blocker, index) =>  <div className='joinErrItem' key={index}> * {blocker} </div>  )}
                                
                           </div> }

    { ourActions &&           <div>
                                <div className='joinErrItemTitle'>What we're doing about it:</div>
                                <div >{
                                ourActions.map( (ourAction, index) => <div className='joinErrItem' key={index}>- {ourAction} </div>)
                                }</div>
                              </div> }

    { userActions         &&  <div> 
                                <div className='joinErrItemTitle'>What can you do?</div>
                                <div > {
                                userActions.map( (userAction, index) => <div className='joinErrItem' key={index}>- {userAction}</div>)
                                } </div> 
                              </div> }

    { supportOptions      &&  <div> 
                                <div className='joinErrItemTitle'>Support Options:</div>
                                <div> {supportOptions.map( (supportOption , index) => <div className='joinErrItem' key={index}> - {supportOption} </div>)} </div> 
                              </div> }
    { progressOptions     &&  <div>
                                <div className='joinErrItemTitle'>Issue Progress Tracking: </div>
                                <div>
                                  {progressOptions.map( (progressOption, index) => <div className='joinErrItem' key={index}> - {progressOption}</div>)}
                                </div>
                              </div>}

  </div>
  )
}
